import { render, staticRenderFns } from "./business_time.vue?vue&type=template&id=63f1158c&scoped=true&"
import script from "./business_time.vue?vue&type=script&lang=ts&"
export * from "./business_time.vue?vue&type=script&lang=ts&"
import style0 from "./business_time.vue?vue&type=style&index=0&id=63f1158c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1158c",
  null
  
)

export default component.exports